/** @prettier */
import { AnalyticsCategories } from '../afterBlocks/analytics/analyticsCategories';
import { initBuyButtonsInBlock, initSubscribing } from '../helpers/cta';
import affiliate from './affiliate';

export default ({ block, data, translations }) => {
  initBuyButtonsInBlock({
    analyticsCategory: AnalyticsCategories.CTA,
    block,
    data,
    translations,
  });
  initSubscribing({ analyticsCategory: AnalyticsCategories.CTA, block, data });
  affiliate({ block });
};
